import {z} from 'zod'
import {RecommendationSource} from '../recommendation/RecommendationSource.js'
import {ProjectId} from '../projects/index.js'
import {TimeEntryId} from './TimeEntryId.js'
import {DateRange} from '@package/shared'

export const TimeEntry = z
  .object({
    id: TimeEntryId,
    breakHours: z.number().min(0).default(0),
    description: z.string().nullish(),
    projectId: ProjectId,
    source: RecommendationSource.nullish(),
  })
  .extend(DateRange.shape)
export type TimeEntry = z.infer<typeof TimeEntry>
